export default __webpack_public_path__ + "static/media/cracked-phone.da075427.png";